import { useCallback, useEffect, useState } from 'react'
import { rpc, useRpcEvent } from '../api/rpc'

export function useInboxCounts() {
  const [counts, setCounts] = useState({ approvals: 0, notifications: 0 })
  const load = useCallback(() => rpc.call<typeof counts>('inbox.counts').then(setCounts).catch(() => undefined), [])
  useEffect(() => { void load() }, [load])
  useRpcEvent('approval.created', () => void load())
  useRpcEvent('approval.resolved', () => void load())
  useRpcEvent('notification', () => void load())
  useRpcEvent('notifications.read', () => void load())
  useRpcEvent('rpc.reconnected', () => void load())
  return counts
}
